// extracted by mini-css-extract-plugin
module.exports = {"activity":"styles-module__activity___1UZex"};